import "../style/Salon.css";

function Salon({ expandAccordion, accordion }) {
  return (
    <>
      <div className="front-slide">
        <span className="front-text">LE SALON</span>
      </div>
      <article className="salon">
        <div className="paragraph" id="paragraph1">
          <div className="text">
            Bienvenue à L'Appart' d'Enzo, un lieu unique où l’on vient avant tout
            prendre du temps pour soi.
          </div>
          <img src="img/interieur5.jpg" alt="Salon" />
        </div>
        <div className="paragraph" id="paragraph2">
          <div className="text">
            Pensé comme un appartement privé, notre espace vous invite à vivre
            une expérience de beauté et de bien-être dans une atmosphère chic,
            cosy et décontractée.
          </div>
          <img src="img/interieur6.jpg" alt="Salon" />
        </div>
        <div className="card">
          <ul>
            {[1, 2, 3, 4].map((numDiv) => {
              return (
              <li id={`cardSubtext${numDiv}`} style={numDiv === 4 ? {borderBottom : 0, paddingBottom : 0} : {}}>
                <h3 className="subtext-title" onClick={() => expandAccordion(numDiv)}>
                  <button>
                    <span className="subtext-title-text">
                      {
                        (numDiv === 1 && `Un concept exclusif inspiré de 18 ans d’expertise`) ||
                        (numDiv === 2 && `Un lieu de vie, de style et de rencontres`) ||
                        (numDiv === 3 && `Une expérience pensée dans les moindres détails`) ||
                        (numDiv === 4 && `Une communauté d’artistes au service de votre image`)
                      }
                    </span>
                    <span className={`subtext-title-accordion-icon ${accordion === numDiv ? "expand" : ""}`}>
                      &lt;
                    </span>
                  </button>
                </h3>
                <div className={`subtext-text ${accordion === numDiv ? 'show' : 'hide'}`}>
                  {
                    (numDiv === 1 && `Après près de deux décennies passées dans les salons les plus
                                      prestigieux de Paris, Enzo a souhaité créer un lieu à son image
                                      : raffiné, humain et généreux. Loin des standards impersonnels,
                                      L’Appart’ d’Enzo propose une vision nouvelle du salon de
                                      coiffure : plus intime, plus chaleureux, plus libre.`) ||

                    (numDiv === 2 && `Ici, on ne vient pas simplement pour une coupe ou une couleur.
                                      On vient vivre une parenthèse. Que ce soit pour un rendez-vous
                                      beauté, une discussion entre amis, un moment de détente ou
                                      même une rencontre professionnelle, chaque passage à l’Appart’
                                      est une invitation à ralentir et se reconnecter à soi.`) ||

                    (numDiv === 3 && `Notre espace, inspiré des clubs privés, marie décoration soignée,
                                      ambiance feutrée et services haut de gamme : boissons, encas, 
                                      attentions personnalisées... Le confort et le plaisir sont au cœur 
                                      de chaque instant. La technologie joue également un rôle essentiel,
                                      avec un soin particulier apporté à l’acoustique, à la lumière et à
                                      l’ambiance générale pour sublimer chaque moment passé chez nous.`) ||

                    (numDiv === 4 && `Nous développons un collectif de 4 à 6 artistes indépendants, tous
                                      animés par la même passion, le même sens du détail et un état
                                      d’esprit collaboratif. Chacun d’eux participe à faire vivre le lieu
                                      tout en gardant son identité propre, dans un cadre stimulant et 
                                      évolutif, où les talents peuvent s’épanouir et grandir.`)
                  }
                  <div className="image-container">
                    <img 
                    src={`img/${
                      (numDiv === 1 && `interieur1.jpg`) ||

                      (numDiv === 2 && `interieur5.jpg`) ||

                      (numDiv === 3 && `interieur6.jpg`) ||

                      (numDiv === 4 && `interieur4.jpg`)
                    }`} 
                    alt={`${
                      (numDiv === 1 && `Piece du salon 1`) ||

                      (numDiv === 2 && `Pièce centrale du salon, dans une ambiance tamisée.`) ||

                      (numDiv === 3 && `Piece du salon 3`) ||

                      (numDiv === 4 && `Piece du salon 4`)
                    }`}
                    className={`${
                      (numDiv === 1 && `first`) ||

                      (numDiv === 2 && `second`) ||

                      (numDiv === 3 && `third`) ||

                      (numDiv === 4 && `fourth`)
                    }-img`}
                    />
                  </div>
                </div>
              </li>
              )
            })}
          </ul>
        </div>
      </article>
    </>
  );
}

export default Salon;
